import { render, staticRenderFns } from "./BtnExcluirAporteParceiro.vue?vue&type=template&id=61738502"
import script from "./BtnExcluirAporteParceiro.vue?vue&type=script&lang=js"
export * from "./BtnExcluirAporteParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports